import { helper as buildHelper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';
export function backgroundColor([color]) {
  if (!color) {
    return null;
  }
  const matches = color.match(/^#?([\da-z]{3,6})$/i);
  const safeColor = matches ? matches[1] : null;
  if (!safeColor) {
    return null;
  }
  return htmlSafe(`background-color: #${safeColor};`);
}
export default buildHelper(backgroundColor);